<template>
  <v-container>
    <component  :is="'script'" type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage":"https://hot-linux.dev/customercomments",
        "headline":"Hot Linux ／ WEBシステム開発（お客様の声）",
        "description":"Hot Linuxでは小規模WEBシステム開発やPHPプログラミングのアドバイスを中心にお引き受けしております。法人様だけでなく個人事業主様・個人様からの相談も大歓迎です。このページではご依頼頂いたクライアント様の声を紹介しています。ほぼ100%ご満足いただいています。ありがとうございます。",
        "image":[
          "https://hot-linux.dev/img/hot-linux-logos_purple.de39c269.webp"
        ],
        "author":{
          "@type":"Person",
          "name":"山田昌史",
          "url":"https://hot-linux.dev/"
        }
      }
    </component>

    <v-row>
      <v-col cols="12" md="6">
        <left-side>
        </left-side>
      </v-col>
      <v-col cols="12" md="6">
        <v-breadcrumbs
          icon="mdi-account-tie-voice-outline"
          bg-color="grey-lighten-4"
          rounded
        >
        <h3>お客様の声</h3>
        </v-breadcrumbs>
        <v-card class='mx-3 my-3'>
          <v-card-text>
            <v-btn
              block
              color='primary'
              @click="onClickOpenDialog()"
              >ぜひこちらからメッセージをお寄せください。
            </v-btn>
          </v-card-text>
        </v-card>
        <template v-for='(row,index) in お客様の声rtn' :key='index'>
          <v-card class='mx-3 my-3'>
            <v-card-title>
              {{row.依頼内容}}
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-rating
                    hover
                    :length="5"
                    :size="32"
                    v-model="row.評価"
                    active-color="yellow"
                    readonly
                  >
                  </v-rating>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <span v-html='row.感想'></span>
                  <!--
                  <br>
                  {{日付表示(row.created_at)}}
                  -->
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </v-col>
    </v-row>
  </v-container>
  <v-dialog v-model="dialog">
    <v-container>
      <v-card>
        <v-card-title>
          お客様の声
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model='selectedRow.依頼内容'
                label="ご依頼いただいた内容"
                variant="outlined"
                placeholder="WEBシステム開発"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              評価：
              <v-rating
                hover
                :length="5"
                :size="32"
                v-model="selectedRow.評価"
                active-color="yellow"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model='selectedRow.感想'
                label="ご感想"
                variant="outlined"
                placeholder="期待以上の出来でした。また依頼したいと思います。"
                ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click='dialog=false' class='ml-5'><v-icon>mdi-arrow-left</v-icon>戻る</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled='!selectedRow.依頼内容||!selectedRow.評価||!selectedRow.感想'
            @click='onClick保存()'
          
          ><v-icon>mdi-content-save</v-icon>送信</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>
<script>
import LeftSide from './LeftSide.vue'
export default {
  components: { LeftSide },

  data(){
    return {
      お客様の声rtn:[],
      dialog:false,
      selectedRow:{},
    };
  },

  computed:{
    日付表示(){
      return function(datetime){
        let date = new Date(datetime);
        return date.getFullYear() + "-" + ("00"+(date.getMonth()+1)).slice(-2) + "-"+("00"+(date.getDate()+1)).slice(-2) 
      }

    }
  },

  mounted(){
    this.お客様の声取得();
  },
  methods:{
    お客様の声取得(){
      this.$emit('overlay');
      let url = './api/api.php';
      let data = {
        func:"お客様の声取得",
      };

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        this.お客様の声rtn = result.お客様の声rtn;
        this.$emit('overlay');
      })
      .catch(error =>{
        console.log(error)
        alert('取得できませんでした。\n\n'+error.body);
        this.$emit('overlay');
      })
    },

    onClickOpenDialog(){
      this.dialog = true;
    },

     onClick保存(){
      this.$emit('overlay');

      let url = './api/api.php';
      let data = this.selectedRow;
      data.func="お客様の声保存"

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        console.log(result);
        this.dialog = false;
        this.お客様の声取得();
        this.$emit('overlay');
      })
      .catch(error =>{
        console.log(error)
        alert('保存できませんでした。\n\n'+error.body);
        this.$emit('overlay');
      })
    },
  },


}
</script>